var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolidCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa6-solid:check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8453 7.84518C17.4962 7.1943 17.4962 6.13903 16.8453 5.48816C16.1944 4.83728 15.1392 4.83728 14.4883 5.48816L9.00012 10.9763L6.8453 8.82149C6.19443 8.17061 5.13915 8.17061 4.48828 8.82149C3.8374 9.47236 3.8374 10.5276 4.48828 11.1785L7.82161 14.5118C8.47248 15.1627 9.52776 15.1627 10.1786 14.5118L16.8453 7.84518Z",
    fill: "#0E6AF4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidCheck);
export default __webpack_public_path__ + "static/media/solid_check.33459568cf9afdd80b917b77a3fa7b9a.svg";
export { ForwardRef as ReactComponent };